import { useCallback, useEffect, useState } from 'react';
import Swal from 'sweetalert2';

const CLAVE_ANCHO = 'caav_panel_ancho';
const ANCHO_MINIMO = 340;

const limitarAncho = ancho => Math.min(Math.max(ancho, ANCHO_MINIMO), Math.round(window.innerWidth * 0.7));

const anchoInicial = () => {
    try {
        const guardado = Number(localStorage.getItem(CLAVE_ANCHO));
        if (guardado) return limitarAncho(guardado);
    } catch {}
    return limitarAncho(Math.round(window.innerWidth * 0.4));
};

export const confirmarDescartar = async () => (await Swal.fire({
    icon: 'question',
    title: 'Hay cambios sin guardar',
    text: 'Si continúas se pierden. ¿Descartarlos?',
    showCancelButton: true,
    confirmButtonText: 'Sí, descartar',
    cancelButtonText: 'Seguir editando'
})).isConfirmed;

// `abierto` es el nombre del panel visible ('editar', 'agregar'...) o null
const usePanelEdicion = ({ hayCambios = false, onCerrar } = {}) => {
    const [abierto, setAbierto] = useState(null);
    const [ancho, setAncho] = useState(anchoInicial);
    const [arrastrando, setArrastrando] = useState(false);

    const abrir = useCallback(nombre => setAbierto(nombre), []);

    // forzar: cerrar sin preguntar, p. ej. después de guardar
    const cerrar = async ({ forzar = false } = {}) => {
        if (!forzar && hayCambios && !(await confirmarDescartar())) return false;
        onCerrar?.(abierto);
        setAbierto(null);
        return true;
    };

    const iniciarArrastre = e => {
        e.preventDefault();
        setArrastrando(true);
    };

    useEffect(() => {
        if (!arrastrando) return;
        const mover = e => setAncho(limitarAncho(e.clientX));
        const soltar = () => setArrastrando(false);
        // La clase desactiva transiciones y los clics del iframe, que si no se "come" el mousemove
        document.body.classList.add('redimensionando_panel');
        window.addEventListener('mousemove', mover);
        window.addEventListener('mouseup', soltar);
        return () => {
            document.body.classList.remove('redimensionando_panel');
            window.removeEventListener('mousemove', mover);
            window.removeEventListener('mouseup', soltar);
        };
    }, [arrastrando]);

    useEffect(() => {
        if (arrastrando) return;
        try {
            localStorage.setItem(CLAVE_ANCHO, String(ancho));
        } catch {}
    }, [arrastrando, ancho]);

    return { abierto, abrir, cerrar, ancho, iniciarArrastre };
};

export default usePanelEdicion;
